// import ScrollOut
import ScrollOut from "scroll-out";

// Fade Up Effect Animation on any item with the .fadeinup class
ScrollOut({
    targets:'.home .wp-block-cover:has(.wp-block-lazyblock-eight-column-width + .wp-block-lazyblock-ten-column-width), .page-template-no-title .wp-block-cover:has(.has-background-dim-0) .wp-block-lazyblock-eight-column-width',
    onShown: function(el) {
        // Only trigger the animation once
           if (!el.classList.contains('animated-once')) {
            // Add the animate.css classes
            el.classList.add('animate__animated', 'animate__fadeInUp');
            // Add a custom class to mark it as animated
            el.classList.add('animated-once');
        }
    },
    once: true // Ensures ScrollOut only triggers the animation once
});
// Fade Right Effect Animation on any item with the .fadeinright class
ScrollOut({
    targets:'.home .wp-block-columns .wp-block-column:last-child:not(:nth-child(4), :has(.wp-block-image + p)):has(.wp-block-image), .page-template-no-title .wp-block-columns .wp-block-column:last-child:not(:nth-child(4), :has(.wp-block-image + p)):has(.wp-block-image)',
    onShown: function(el) {
        // Only trigger the animation once
           if (!el.classList.contains('animated-once')) {
            // Add the animate.css classes
            el.classList.add('animate__animated', 'animate__fadeInRight');
            // Add a custom class to mark it as animated
            el.classList.add('animated-once');
        }
    },
    once: true // Ensures ScrollOut only triggers the animation once
});
// Fade Left Effect Animation on any item with the .fadeinleft class
ScrollOut({
    targets:'.home .wp-block-columns:not(:has(.wp-block-column:nth-child(4))) .wp-block-column:first-child:not(:has(.wp-block-image + p)):has(.wp-block-image), .page-template-no-title .wp-block-columns:not(:has(.wp-block-column:nth-child(4))) .wp-block-column:first-child:not(:has(.wp-block-image + p)):has(.wp-block-image)',
    onShown: function(el) {
        // Only trigger the animation once
        if (!el.classList.contains('animated-once')) {
            // Add the animate.css classes
            el.classList.add('animate__animated', 'animate__fadeInLeft');
            // Add a custom class to mark it as animated
            el.classList.add('animated-once');
        }
    },
    once: true // Ensures ScrollOut only triggers the animation once
});
//
import Lightbox from './bs5-lightbox';

const options = {
	keyboard: true
};

document.querySelectorAll('[data-toggle="lightbox"]').forEach((el) => el.addEventListener('click', (e) => {
	e.preventDefault();
	const lightbox = new Lightbox(el, options);
	lightbox.show();
}));
//
// import Swiper JS
import Swiper from 'swiper';
import { Autoplay, Navigation, Pagination } from 'swiper/modules';

const swiper = new Swiper('.swiper', {
    // Optional parameters
    //direction: 'vertical',
	modules: [Autoplay, Navigation, Pagination],
    loop: true,
	slidesPerView: 1,
	breakpoints: {
		992:{
			slidesPerView: 2,
			spaceBetween: 24
		}
	},
	autoHeight: true, // Make slides equal height
	autoplay: {
		delay: 10000,
	},
	// Navigation arrows
	navigation: {
		nextEl: '.swiper-button-next',
		prevEl: '.swiper-button-prev',
	},
});
//
// Back to Top Button
// Get the button
var mybutton = document.getElementById("btn-back-to-top");
// When the user scrolls down 20px from the top of the document, show the button
window.onscroll = function () {
    scrollFunction();
};
//
function scrollFunction() {
    if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
        mybutton.style.display = "block";
    }
    else {
        mybutton.style.display = "none";
    }
}
// When the user clicks on the button, scroll to the top of the document
mybutton.addEventListener("click", backToTop);
//
function backToTop() {
    jQuery("html, body").animate({ scrollTop: 0 }, "slow");
}
//
// Initialize and add the map
let map;
async function initMap() {
  // Request needed libraries.
  //@ts-ignore
  const { Map } = await google.maps.importLibrary("maps");
  const { AdvancedMarkerElement } = await google.maps.importLibrary("marker");

  // The map, centered at Uluru
  map = new Map(document.getElementById("map"), {
    zoom: 13,
    center: { lat: 50.5610, lng: -4.9193 },
    mapId: "saunas-map",
  });
  //
  // A marker with a with a URL pointing to a PNG.
  const babybayMarkerImg = document.createElement("img");
  babybayMarkerImg.src = "https://www.saunasbythesea.co.uk/wp-content/themes/saunasbythesea/img/marker-sauna.svg";
  //
  const harlynbayMarkerImg = document.createElement("img");
  harlynbayMarkerImg.src = "https://www.saunasbythesea.co.uk/wp-content/themes/saunasbythesea/img/marker-sauna.svg";
  //
  const wildspaMarkerImg = document.createElement("img");
  wildspaMarkerImg.src = "https://www.saunasbythesea.co.uk/wp-content/themes/saunasbythesea/img/marker-wild-spa.svg";
  //
  const marker = new AdvancedMarkerElement({
    map: map,
    position: { lat: 50.5783, lng: -4.9165 },
    content: babybayMarkerImg,
    title: "Baby Bay Polzeath",
  });
  //
  const marker2 = new AdvancedMarkerElement({
    map: map,
    position: { lat: 50.5385, lng: -4.9974 },
    content: harlynbayMarkerImg,
    title: "Harlyn Bay Beach",
  });
  //
  const marker3 = new AdvancedMarkerElement({
    map: map,
    position: { lat: 50.5726, lng: -4.9158 },
    content: wildspaMarkerImg,
    title: "Polzeath Wild Spa",
  });
}
if (document.getElementById('map')) {
    initMap();
}
//
// Function to add the button to the form when it's available
async function addButtonToForm() {
    //alert('adding form');
    // Select the form with the class 'el-form'
    const form = document.querySelector('.am-fs__init-form');

    // Check if the form exists
    if (form && !form.querySelector('.custom-button')) {  // Check if the button isn't already added
        //alert('form exists');
        //isButtonAdded = true;
        //observer.disconnect(); // Stop observing after first run
        //
        // reset form
        //alert('Starting reset...');
        await resetForm();
        //alert('Reset complete. Proceeding with other code...');
        //
        let serviceHeading = false;
        const location = document.createElement("h3");
        const service = document.createElement("h3");
        location.append("*Location");
        service.append("*Service");
        service.style.display = 'none';
        //location.style.color = "#2F2E2C";
        form.append(location);
        document.querySelectorAll('.el-popper.am-select-popper .am-select-option').forEach((item, index) => {
            if (item.closest('.el-popper.am-select-popper').classList.contains('am-service-dropdown') && !serviceHeading) {
                serviceHeading = true;
                form.append(service);
                //service.style.color = "#2F2E2C";
            }
            const newButton = document.createElement('button');
            const buttonText = item.querySelector('span').innerText;
            newButton.id = `button-${index}`;
            newButton.type = 'button';  // Set to 'submit' if you want it to submit the form
            newButton.innerText = buttonText;
            newButton.classList.add('custom-button','btn','btn-primary','location-button');  // Add a custom class for styling
            if (item.closest('.el-popper.am-select-popper').classList.contains('am-service-dropdown')) {
                newButton.style.display = 'none';
                newButton.classList.remove('location-button');
                newButton.classList.add('service-button');
            }
            //
            form.append(newButton);
        });
        //
        addEventListenerToButtons(service);
        //observer.disconnect();
    }
}

function addEventListenerToButtons(service) {
    document.querySelectorAll('.custom-button').forEach((item, index) => {
        item.addEventListener('click', function() {
            // Remove 'active' class from all buttons before adding to the clicked one
            if (item.classList.contains('location-button')) {
                document.querySelectorAll('.custom-button').forEach(btn => btn.classList.remove('active'));
                item.classList.add('active');
                service.style.display = 'block';
                //
                const element = document.querySelector('.am-service-select .el-input__suffix');
                //
                if (element) {
                    // Listen for the mouseover event
                    element.addEventListener('mouseover', () => {
                        // Delay execution slightly to allow any DOM changes to take effect
                        setTimeout(() => {
                            const clearService = document.querySelector('.am-service-select .el-input__suffix .am-icon-close');
                            if (clearService) {
                                clearService.click();
                            }
                        }, 100); // Adjust delay as needed
                    });
                
                    // Simulate hover (mouseenter and mouseover)
                    element.dispatchEvent(new Event('mouseenter', { bubbles: true }));
                    element.dispatchEvent(new Event('mouseover', { bubbles: true }));
                }
            }
            else{
                document.querySelectorAll('.service-button').forEach(btn => btn.classList.remove('active'));
                this.classList.add('active');
            }
            //
            setTimeout(() => {
                // Select all elements with the class '.am-select-option'
                const options = document.querySelectorAll('.am-select-option');

                // Find the element that contains a <span> with the specific text
                const targetOption = Array.from(options).find(option => {
                    const span = option.querySelector('span'); // Find the <span> inside the option
                    return span && span.textContent.trim() === item.innerText; // Check the text content
                });

                if (targetOption) {
                    console.log('Found the target element:', targetOption);
                    targetOption.click();
                    setTimeout(() => {
                        updateServicesButtons();
                    }, 100);
                } else {
                    console.log('Element not found');
                }
            }, 200); // Adjust the delay as needed (500ms = 0.5s)
        });
    });
    document.querySelector('.am-button-continue').addEventListener('click', function() {
        hasRun = false;
    });
}
//
function updateServicesButtons() {
    document.querySelectorAll('.am-select-option').forEach(item => {
        const options = document.querySelectorAll('.am-select-option');
        const buttons = document.querySelectorAll('.custom-button');
        //
        buttons.forEach(button => {
            //button.disabled = false;
            //button.style.visibility = 'visible';
            button.style.display = 'inline';
            let found = false;
            //alert('button = ' + button.textContent.trim());
            options.forEach(option => {
                const span = option.querySelector('span'); // Get the first <span>
                const optionText = span?.textContent.trim(); // Get its text safely
                //alert('option = ' + optionText);
                if (button.textContent.trim() === optionText) {
                    found = true;
                    //alert('Match found');
                    //console.log("Match found:", button.textContent.trim());
                    return; // Exit inner loop
                }
            });
            //alert('found' + found);
            if (found) {
                return; // Exit outer loop
            }
            else{
                //alert('Match not found');
                //button.disabled = true;
                //button.style.visibility = 'hidden';
                if (button.classList.contains('service-button')) {
                    button.style.display = 'none';
                }
                else{
                    //button.disabled = true;
                    //document.querySelectorAll('.am-service-select .am-select-wrapper .el-input__suffix').style.display = 'none';
                    //document.querySelectorAll('.am-service-select').style.display = 'none';
                    //alert('done');
                }
            }
        });
    });
}

//let isResetting = false; // Flag to prevent multiple executions
function resetForm(){
    //alert('reset form');
    return new Promise((resolve) => {
        //if (isResetting) return; // Prevent multiple simultaneous calls
        //isResetting = true;
        //
        const garry = document.querySelector('.am-location-select .el-input__suffix');
        // Select the second element
        const secondElement = document.querySelector('.am-service-select .el-input__suffix'); 
        //
        if (garry && secondElement) {
            let pending = 2; // Track completion of both timeouts
            // Listen for the mouseover event
            garry.addEventListener('mouseover', () => {
                // Delay execution slightly to allow any DOM changes to take effect
                setTimeout(() => {
                    const clearLocation = document.querySelector('.am-location-select .el-input__suffix .am-icon-close');
                    if (clearLocation) {
                        clearLocation.click();
                    }
                    if (--pending === 0) {
                        //isResetting = false;
                        resolve(); // Resolve when both complete
                    }
                }, 100); // Adjust delay as needed
                //garry.removeEventListener('mouseover', handleMouseOver); // Remove listener
            });
            //
            // Listen for the mouseover event on the second element
            secondElement.addEventListener('mouseover', () => {
                // Delay execution slightly to allow any DOM changes to take effect
                setTimeout(() => {
                    const clearService = document.querySelector('.am-service-select .el-input__suffix .am-icon-close');
                    if (clearService) {
                        clearService.click();
                    }
                    if (--pending === 0) resolve(); // Resolve when both complete
                }, 100); // Adjust delay as needed
            });
        
            // Simulate hover (mouseenter and mouseover)
            garry.dispatchEvent(new Event('mouseenter', { bubbles: true }));
            garry.dispatchEvent(new Event('mouseover', { bubbles: true }));
            //
            // Simulate hover (mouseenter and mouseover) for the second element
            secondElement.dispatchEvent(new Event('mouseenter', { bubbles: true }));
            secondElement.dispatchEvent(new Event('mouseover', { bubbles: true }));
        }
        else {
            // If elements are missing, resolve immediately
            resolve();
        }
    });
}

let hasRun = false; // Flag to ensure single execution
// Set up a MutationObserver to watch for the addition of the form
const observer = new MutationObserver((mutations) => {
    if (hasRun) return; // Skip if already executed
    mutations.forEach((mutation) => {
        if (mutation.type === 'childList') {
            // Check if the target form element exists
            const formElement = document.querySelector('.am-fs__init-form');
            if (formElement && !hasRun) {
                hasRun = true; // Set the flag immediately
                //alert('found');
                // Call your async function
                //(async () => {
                    //await addButtonToForm(); // Your async function
                    addButtonToForm(); // Try adding the button whenever the DOM is updated
                    //observer.disconnect();
                //})();
            }
        }
    });
});

// Start observing the document body for changes
observer.observe(document.body, {
    childList: true,
    subtree: true,
});
//


//
jQuery(document).ready(function($){
    $('.wp-block-button').each(function() {
        var buttonText = $(this).text().trim();
        // Check if the text content is 'Shop Now'
        if (buttonText.includes('Shop')) {
          // Add a background image
          //$(this).css({
            //'background-image': "url('https://example.com/your-image.jpg')",
            //'background-size': 'cover', // Ensure the image covers the button
            //'background-position': 'center' // Center the image
          //});
          // Add a class 'shop'
          $(this).find('.wp-block-button__link').addClass('icon-shop');
        }
        //
        if (buttonText.includes('Sauna')) {
            $(this).find('.wp-block-button__link').addClass('icon-sauna');
        }
        //
        /*if (buttonText === 'Beach Saunas' || buttonText.includes('Book a Sauna') || buttonText === 'Book a Beach Sauna') {
            $(this).find('.wp-block-button__link').addClass('icon-sauna');
        }*/
        //
        if (buttonText.includes('Wild Spa') || buttonText.includes('Class') || buttonText.includes('Pilates') || buttonText.includes('About')) {
            $(this).find('.wp-block-button__link').addClass('icon-wild-spa');
        }
        //
        /*if (buttonText === 'Wild Spa' || buttonText === 'Book a Class' || buttonText === 'Pilates' || buttonText === 'More about us' || buttonText === 'Visit Polzeath Wild Spa') {
            $(this).find('.wp-block-button__link').addClass('icon-wild-spa');
        }*/
        //
        if (buttonText === 'Find out more') {
            $(this).find('.wp-block-button__link').addClass('icon-find-out-more');
        }
        //
        /*if (buttonText === 'Become a member' || buttonText === 'Sign up for a Membership' || buttonText === 'Sign up for your membership') {
            $(this).find('.wp-block-button__link').addClass('icon-member');
        }*/
        //
        if (buttonText.includes('Member')) {
            $(this).find('.wp-block-button__link').addClass('icon-member');
        }
        //
        if (buttonText.includes('Book') && !buttonText.includes('Sauna')) {
            $(this).find('.wp-block-button__link').addClass('icon-calendar');
        }
        /*if (buttonText === 'Book now') {
            $(this).find('.wp-block-button__link').addClass('icon-calendar');
        }*/
        //
        if (buttonText === 'Boot Camp Circuits') {
            $(this).find('.wp-block-button__link').addClass('icon-boot-camp-circuits');
        }
        //
        if (buttonText === 'Slow Flow Yoga') {
            $(this).find('.wp-block-button__link').addClass('icon-slow-flow-yoga');
        }
        //
        if (buttonText === 'Sound Bath, Gongs & Bowls') {
            $(this).find('.wp-block-button__link').addClass('icon-sound-bath');
        }
        //
        /*if (buttonText === 'Get in touch with us') {
            $(this).find('.wp-block-button__link').addClass('icon-envelope');
        }*/
        //
        if (buttonText.includes('Touch')) {
            $(this).find('.wp-block-button__link').addClass('icon-envelope');
        }
    });
    //
    $('a[href^="#block-"]').on('click', function(e){
        e.preventDefault();
        //
        var headerHeight = $('#wrapper-navbar').outerHeight();
        var link = $(this).attr('href');
        var linkOffset = $(link).offset().top - headerHeight;
        //
        $('html, body').animate({
            scrollTop:linkOffset
        }, 'slow');
    });
});